import { useEffect, useState } from "react";
import { Slider } from "./ui/slider";
import { Check, Mars, Venus } from "lucide-react";

export const BodyControls = ({ t, sex, setSex, age, setAge }) => {
  const [open, setOpen] = useState(true);
  const [draft, setDraft] = useState(age);
  useEffect(() => setDraft(age), [age]);
  const confirm = () => { setAge(draft); setOpen(false); };

  return (
    <>
      {open ? (
        <div className="fixed inset-0 z-30 grid place-items-center bg-white/25 px-5 backdrop-blur-[3px]" data-testid="body-controls-overlay">
        <div className="card fade-up w-full max-w-[420px] rounded-[2rem] p-6 sm:p-8" data-testid="body-controls">
          <p className="font-display text-center text-2xl font-bold text-slate-900">{t("patient")}</p>
          <div className="mt-5 grid grid-cols-2 gap-3">
            {[["female", Venus], ["male", Mars]].map(([s, Icon]) => (
              <button key={s} data-testid={`sex-${s}-btn`} onClick={() => setSex(s)}
                className={`flex flex-col items-center gap-2 rounded-2xl border-2 py-5 text-base font-semibold transition-colors ${sex === s ? "border-teal-700 bg-teal-50 text-sage" : "border-slate-200 bg-white text-slate-500 hover:border-slate-300 hover:text-slate-800"}`}>
                <Icon size={34} strokeWidth={2.2} />{t(s)}
              </button>
            ))}
          </div>
          <div className="mt-6 flex items-baseline justify-between">
            <span className="label">{t("age")}</span>
            <span className="font-display text-3xl font-bold text-slate-800" data-testid="age-value">{draft} <span className="text-sm font-normal text-slate-500">{t("years")}</span></span>
          </div>
          <Slider data-testid="age-slider" className="age-slider age-slider-lg mt-2 py-4" min={1} max={100} step={1} value={[draft]} onValueChange={(v) => setDraft(v[0])} onValueCommit={(v) => setAge(v[0])} />
          <button data-testid="profile-confirm-btn" onClick={confirm} className="btn-primary mt-6 w-full !py-3.5 text-base"><Check size={18} />{t("confirm")}</button>
        </div>
        </div>
      ) : (
        <div className="absolute left-4 top-20 z-10 sm:left-6">
        <button data-testid="profile-collapsed-btn" onClick={() => setOpen(true)}
          aria-label={`${t("patient")}: ${t(sex)} · ${age}`} title={`${t("patient")}: ${t(sex)} · ${age}`}
          className="fade-up relative grid h-10 w-10 place-items-center rounded-full bg-sage text-white shadow-md transition-transform hover:scale-105">
          {sex === "female" ? <Venus size={20} data-testid="profile-icon-female" /> : <Mars size={20} data-testid="profile-icon-male" />}
          <span className="absolute -bottom-1 -right-1 rounded-full bg-white px-1 text-[9px] font-bold leading-4 text-slate-700 shadow" data-testid="profile-collapsed-age">{age}</span>
        </button>
        </div>
      )}
    </>
  );
};
